import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Mail, Menu, X } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";
import { goTo, SETUP_MAILTO } from "./homeData";

const LINKS = [["Proof of work", "proof"], ["Features", "features"], ["Walkthroughs", "walkthroughs"], ["How it works", "how"], ["Pricing", "pricing"], ["FAQ", "faq"], ["Get in touch", "contact"]];

export const HomeHeader = ({ onStart }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const nav = (id) => { setOpen(false); setTimeout(() => goTo(id), 60); };
  const home = () => (["/", "/home"].includes(pathname) ? window.scrollTo({ top: 0, behavior: "smooth" }) : navigate("/home"));
  return (
    <header className="sticky top-0 z-50 bg-[#0B1120]/90 backdrop-blur-xl border-b border-white/10" data-testid="home-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center gap-4">
        <button onClick={home} data-testid="home-logo-btn" aria-label="Cross Jobs home">
          <BrandMark tone="light" size="sm" />
        </button>
        <nav className="hidden lg:flex items-center gap-1 ml-6">
          {LINKS.map(([label, id]) => (
            <button key={id} onClick={() => nav(id)} data-testid={`home-nav-${id}`}
              className={`${id === "contact" ? "hidden xl:inline-flex" : ""} whitespace-nowrap px-2 xl:px-3 py-2 rounded-full text-sm font-medium text-slate-300 hover:text-white hover:bg-white/10 transition-colors`}>{label}</button>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2">
          <Link to={user ? "/" : "/login"} data-testid="home-signin-btn"
            className="hidden sm:inline-flex whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold text-white hover:bg-white/10 transition-colors">
            {user ? "Open dashboard" : "Sign in"}
          </Link>
          <button onClick={onStart} data-testid="home-header-start-btn"
            className="hidden xl:inline-flex whitespace-nowrap px-4 py-2 rounded-full text-sm font-semibold text-white border border-white/20 hover:bg-white hover:text-[#0B1120] transition-colors">
            Free trial
          </button>
          <a href={SETUP_MAILTO} data-testid="home-header-email-btn"
            className="inline-flex items-center gap-2 whitespace-nowrap px-4 sm:px-5 py-2 rounded-full text-sm font-bold bg-[#EA580C] text-white hover:bg-[#C2410C] transition-colors">
            <Mail className="w-4 h-4" />Email us
          </a>
          <button onClick={() => setOpen((o) => !o)} data-testid="home-menu-btn" aria-label="Menu"
            className="lg:hidden w-10 h-10 rounded-full grid place-items-center text-white hover:bg-white/10 transition-colors">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden border-t border-white/10 px-5 py-3 grid gap-1" data-testid="home-mobile-nav">
          {LINKS.map(([label, id]) => (
            <button key={id} onClick={() => nav(id)} data-testid={`home-mobile-nav-${id}`} className="text-left px-3 py-2.5 rounded-lg text-slate-200 hover:bg-white/10 hover:text-white transition-colors">{label}</button>
          ))}
          <Link to={user ? "/" : "/login"} data-testid="home-mobile-signin" className="px-3 py-2.5 rounded-lg font-semibold text-white hover:bg-white/10 transition-colors">
            {user ? "Open dashboard" : "Sign in"}
          </Link>
          <button onClick={() => { setOpen(false); onStart(); }} data-testid="home-mobile-start" className="text-left px-3 py-2.5 rounded-lg font-semibold text-[#FDBA74] hover:bg-white/10 transition-colors">
            Start a free trial yourself
          </button>
        </nav>
      )}
    </header>
  );
};
